import { Constants } from '@adobe/aem-spa-page-model-manager'

import ReactAccordion from '../components/ReactAccordion'
import ReactAddressCapture from '../components/ReactAddressCapture'
import ReactBadge from '../components/ReactBadge'
import ReactBanner from '../components/ReactBanner'
import ReactBBFL from '../components/ReactBBFL'
import ReactButton from '../components/ReactButton'
import ReactCalculator from '../components/ReactCalculator'
import ReactCarousel from '../components/ReactCarousel'
import ReactContentFragment from '../components/ReactContentFragment'
import ReactCountdownClock from '../components/ReactCountdownClock'
import ReactFooter from '../components/ReactFooter'
import ReactFormContainer from '../components/ReactFormContainer'
import ReactHeader from '../components/ReactHeader'
import ReactHtml from '../components/ReactHtml'
import ReactHTMLTag from '../components/ReactHTMLTag'
import ReactImage from '../components/ReactImage'
import ReactLayout from '../components/ReactLayout'
import ReactList from '../components/ReactList'
import ReactModal from '../components/ReactModal'
import ReactOfferElements from '../components/ReactOfferElements'
import ReactOliver from '../components/ReactOliver'
import ReactPrice from '../components/ReactPrice'
import ReactPropertiesCodeBlock from '../components/ReactPropertiesCodeBlock'
import ReactRuleBuilder from '../components/ReactRuleBuilder/ReactRuleBuilder'
import ReactRuleBuilderConditional from '../components/ReactRuleBuilderConditional'
import ReactRuleSearch from '../components/ReactRuleSearch'
import ReactSearch from '../components/ReactSearch'
import ReactSeparator from '../components/ReactSeparator'
import ReactSticky from '../components/ReactSticky'
import ReactTable from '../components/ReactTable'
import ReactTabs from '../components/ReactTabs'
import ReactTeaser from '../components/ReactTeaser'
import ReactText from '../components/ReactText'
import ReactTitle from '../components/ReactTitle'
import ResponsiveContainer from '../components/shared/ResponsiveContainer'
import { COMPONENTS_PATH } from '../constants'
import { RuleType } from '../utils/types'

const ComponentTypeRenderer = (props: {
  componentType: string
  componentProps: any
  condition?: string
  ruleType?: RuleType
  ruleExpression?: string
  ruleId?: string
  index?: number
}) => {
  const { componentType, componentProps, condition, ruleType, ruleExpression = '', index } = props
  const items = componentProps?.[Constants.ITEMS_PROP]
  const itemsOrder = componentProps?.[Constants.ITEMS_ORDER_PROP]
  if (componentType === `${COMPONENTS_PATH}/reactteaser`) {
    return <ReactTeaser {...componentProps} ruleExpression={ruleExpression} condition={condition} ruleType={ruleType} />
  } else if (componentType === `${COMPONENTS_PATH}/experiencefragment`) {
    return (
      <ResponsiveContainer
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
        componentProps={componentProps[Constants.ITEMS_PROP]?.root}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/carousel`) {
    return (
      <ReactCarousel
        autoplay={false}
        autopauseDisabled={false}
        accessibilityLabel={''}
        accessibility={{
          play: 'Play',
          pause: 'Pause',
          next: 'Next',
          previous: 'Previous',
          slide: 'Slide {0} of {1}',
          indicator: 'Slide %{0}',
          indicators: 'Choose a slide to display'
        }}
        delay={0}
        cqItems={{}}
        allowedComponents={{ applicable: false, components: [] }}
        cqItemsOrder={[]}
        cqPath={''}
        {...componentProps}
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/reactbanner`) {
    return <ReactBanner {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/image`) {
    return <ReactImage {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/list`) {
    return <ReactList {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/title`) {
    return <ReactTitle {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/text`) {
    return <ReactText {...componentProps} index={index} />
  } else if (componentType === `${COMPONENTS_PATH}/button`) {
    return <ReactButton {...componentProps} />
  } else if (
    componentType === `${COMPONENTS_PATH}/container` ||
    componentType === `wcm/foundation/components/responsivegrid`
  ) {
    return (
      <ResponsiveContainer
        componentProps={componentProps}
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/accordion`) {
    return <ReactAccordion {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/addresscapture`) {
    return <ReactAddressCapture {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/modal`) {
    return <ReactModal {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} {...props} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcontentfragment`) {
    return <ReactContentFragment {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/footer`) {
    return <ReactFooter {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/form/container`) {
    return <ReactFormContainer {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/header`) {
    return <ReactHeader {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/htmltag`) {
    return <ReactHTMLTag {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/htmlembed`) {
    return <ReactHtml {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/oliver`) {
    return <ReactOliver {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactprice`) {
    return (
      <ReactPrice
        {...componentProps}
        cqItems={items}
        cqItemsOrder={itemsOrder}
        ruleExpression={ruleExpression}
        index={index}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/reactofferelements`) {
    return <ReactOfferElements {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} index={index} {...props} />
  } else if (componentType === `${COMPONENTS_PATH}/propertiescodeblock`) {
    return <ReactPropertiesCodeBlock {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/rulesearch`) {
    return <ReactRuleSearch {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/search`) {
    return <ReactSearch {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/separator`) {
    return <ReactSeparator {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/sticky`) {
    return <ReactSticky {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/tabs`) {
    return <ReactTabs {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactbadge`) {
    return <ReactBadge {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/rulebuilder`) {
    return <ReactRuleBuilder {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/rulebuilderconditional`) {
    return <ReactRuleBuilderConditional {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/react-rte-table/reacttable`) {
    return <ReactTable {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactlayout`) {
    return <ReactLayout cqItems={items} cqItemsOrder={itemsOrder} {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcalculator`) {
    return <ReactCalculator {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactbbfl`) {
    return <ReactBBFL {...componentProps} ruleExpression={ruleExpression} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcountdownclock`) {
    return <ReactCountdownClock {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  }

  return <></>
}

export default ComponentTypeRenderer
